module.exports = __webpack_public_path__ + "img/icon_arrow_down_w.837590d5.svg";